import React from 'react';
import {
    RichCell,
    PanelHeader,
    Cell,
    PanelHeaderButton,
    Div,
    SplitCol,
    SplitLayout,
    Button,
    Switch, Spinner, Pagination, Search, Alert, NativeSelect
} from '@vkontakte/vkui';
import axios from "axios";
import {addDays} from "@vkontakte/vkui/dist/lib/date";
import {
    AdaptivityContext, inducement, setQuizStep
} from "../assets/constants";
import moment from "moment";
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import * as constants from "../assets/constants";
import {
    Icon24PicturePlusOutline, Icon24Refresh,
    Icon24Search
} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import IncomingDocsViewer from "./IncomingDocsViewer";
import {current_theme} from "../index";
import CopyToClipBoard from "../assets/CopyToClipboardButton";


class IncomingDocs extends React.Component {

    state = {
        value: [addDays(new Date(), -90), new Date()],
        items: [],
        showDocsAlert: false,
        dateRangeIsOpen: false,
        monitoring_items: {},
        cnt_docs: 0,
        cnt_meters: 0,
        cnt_bonus: 0,
        loading: true,
        show_sub_docs: true,
        activeModal: null,
        modalHistory: [],
        currentDocId: null,
        append: false,
        page: 1,
        totalPages: 1,
        mainSearch: '',
        showSearch: false,
        currentStatus: '',
        labels: {}
    }

    constructor(props) {


        super(props);

        this.handleScroll = this.handleScroll.bind(this)
        this.ref = React.createRef();
        if (this.props.current_docs_ids && this.props.current_docs_ids.length > 0) {
            this.state.showDocsAlert = true
        }

        this.state.labels[''] = 'Все'
        this.state.labels[constants.CODE_INCOMING_STATUS_NEW] = 'Новый'
        this.state.labels[constants.CODE_INCOMING_STATUS_IN_PROCESS] = 'Идет приемка'
        this.state.labels[constants.CODE_INCOMING_STATUS_SENT] = 'Отправлена'
    }

    dateChange = (e) => {
        console.log(e)
        this.setState({dateRangeIsOpen: false, loading: true, value: e, page: 1, items: []})

        setTimeout(() =>
            this.getItems(), 700)
    }
    changeCurrentStatus = (status) => {

        this.setState({loading: true, currentStatus: status, page: 1, items: []})
        setTimeout(() =>
            this.getItems(), 700)
    }

    getItems = (mainSearch = '', append, page) => {
        clearInterval(this.searchInterval);
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == undefined) {
            mainSearch = this.state.mainSearch
        }
        const currentStatus = this.state.currentStatus

        this.setState({loading: true})
        const body = new FormData()
        body.append('sSearch', mainSearch)
        body.append('page', page)
        if (currentStatus) {
            body.append('status', currentStatus)
        }
        if (this.props.current_user.meta.division && this.props.current_user.meta.division.code) {
            body.append('division', this.props.current_user.meta.division.code)
        }
        body.append('start', this.state.value[0].toLocaleDateString())
        body.append('end', this.state.value[1].toLocaleDateString())
        body.append('epp', AdaptivityContext.isMobile ? 10 : (this.props.is_firm_fit ? 5 : 8))
        body.append('show_sub_docs', this.state.show_sub_docs === true ? 1 : 0)

        if (this.props.is_firm_fit) {
            body.append('is_firm_fit', 1)
        }

        axios.post(this.props.base_url + '?app=incomings&act=showManyJson2', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            this.setState({loading: false})
            let old = this.state.items;
            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            this.setState({items: old})


            this.setState({cnt_docs: response.data.iTotalRecords})
            this.setState({totalPages: response.data.iTotalPages})

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        })

    }

    receiveMessage = (event) => {

        if (event.data.type != undefined) {

        }

    }

    checkScroll = () => {
        if (!this.ref.current) return
        if (this.state.cnt_docs * 1 <= this.state.items.length) return
        let visible = this.ref.current.getBoundingClientRect().top < window.innerHeight - 50;

        if (!this.state.loading && visible) {
            let page = this.state.page
            if (page >= this.state.totalPages * 1) return
            page++;
            this.setState({page: page})

            this.getItems(undefined, true, page)


        }
    }

    handleScroll() {
        this.checkScroll()
    }

    componentDidMount = () => {

        moment.locale('ru')


        this.getItems()
        window.addEventListener("message", this.receiveMessage, false)
        window.addEventListener('scroll', this.handleScroll);


    }
    componentWillUnmount = () => {
        //  localStorage.setItem(photo_ffc_items_key, JSON.stringify(this.state.items_monitoring ? this.state.items_monitoring : {}))
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener("message", this.receiveMessage)
    }


    setPage = (page) => {
        if (page <= this.state.totalPages) {
            this.setState({loading: true, page: page})
            setTimeout(() =>
                this.getItems(this.state.mainSearch, false, page), 600)
        }
    }

    toggleSearch = () => {


        this.setState({showSearch: !this.state.showSearch});

    }

    searchInterval = null;
    element = null;
    onSearchChange = (state) => {


        clearInterval(this.searchInterval);
        this.setState({mainSearch: state.target.value});
        this.searchInterval = setInterval(() => {
            // console.log(state);
            this.setState({loading: true, page: 1});
            this.getItems(this.state.mainSearch, false, 1);
        }, state.target.value == '' ? 500 : 2000);

    }
    getCheckedQnt = () => {
        const result = this.state.items.reduce((accumulator, el) => accumulator + (el.checked ? 1 : 0), 0)
        return result
    }

    render() {

        const num_checked = this.getCheckedQnt()

        const alertDocs = <Alert
            onClose={() => this.setState({showDocsAlert: false})}
            actionsAlign="left"
            actionsLayout="horizontal"
            actions={[
                {
                    title: 'Продолжить',
                    action: () => {
                        this.setState({showDocsAlert: false});
                        setQuizStep(1, "Incoming")
                    },

                },
                {
                    title: 'Создать новую',
                    action: () => {

                        window.postMessage({type: "clearIncoming"})


                        this.setState({showDocsAlert: false, page: 1});
                        setTimeout(() => this.getItems('', false, 1), 500)
                    },
                },
            ]}

            header="Обнаружена не завершённая приемка товаров по данным документам"
            text={[<IncomingDocsViewer
                items={this.props.current_docs}/>, "Продолжить заполнение или создать новый? Все не отправленные в 1С данные будут потеряны!"]}
        />
        const yellowBG = (current_theme == 'dark' ? '#444400' :
            '#d4d409')
        const greenBG = (current_theme == 'dark' ? '#00440e' :
            '#b7f5a8')


        return (
            <SplitLayout popout={this.state.showDocsAlert ? alertDocs : null}>
                <SplitCol>
                    <PanelHeader fixed={true}
                                 before={AdaptivityContext.isMobile ?
                                     <PanelHeaderButton style={{display: 'inline'}}
                                                        onClick={this.toggleSearch}><Icon24Search/></PanelHeaderButton> : ''}
                                 after={!this.state.showSearch || !AdaptivityContext.isMobile ?
                                     <Div style={{display: "flex"}} >
                                         <DateRangePicker
                                             onCalendarClose={() => setTimeout(() => this.setState({dateRangeIsOpen: false}), 1000)}
                                             onClick={() => {
                                                 this.setState({dateRangeIsOpen: true});
                                             }}
                                             showLeadingZeros={true}
                                             value={this.state.value}
                                             isOpen={this.state.dateRangeIsOpen}
                                             key="SaleDocsDateRangePicker"
                                             onChange={this.dateChange}/>
                                         <Button size="s" mode="tertiary" style={{maxWidth: "42px"}} onClick={() => {this.setState({page: 1, items: []}); this.getItems(this.state.mainSearch, false, 1)} } ><Icon24Refresh/></Button>
                                     </Div> : ''}
                    >
                        <Div>
                            {this.state.showSearch || !AdaptivityContext.isMobile ?
                                <Search autoFocus

                                        theme="header"
                                        placeholder="Поиск"
                                        value={this.state.mainSearch}
                                        onChange={this.onSearchChange}
                                        onClose={this.toggleSearch}

                                        style={{flexGrow: '1', maxWidth: '350px'}}
                                /> : AdaptivityContext.isMobile ? '' : ''

                            }

                        </Div>
                    </PanelHeader>
                    <SplitLayout>
                        <SplitCol>
                            <Button before={<Icon24PicturePlusOutline/>} disabled={num_checked == 0}
                                    onClick={() => this.props.current_docs_ids && this.props.current_docs_ids.length > 0 ?
                                        this.setState({showDocsAlert: true}) :
                                        this.startIncoming()}
                                    mode="primary" size="l" stretched>
                                {num_checked ? 'Начать приемку по ' + num_checked + ' ' + inducement(num_checked, 'документу', 'документам', 'документам') :
                                    'Выберите документы'}
                            </Button>
                        </SplitCol>
                        <SplitCol>
                            <Div className="all-docs-block">
                                <NativeSelect
                                    style={{
                                        zIndex: 6,
                                        marginLeft: '10px',
                                        height: '30px',
                                        maxWidth: AdaptivityContext.isMobile && this.props.monitoring_mode ? '150px' : 'inherit'
                                    }}
                                    value={this.state.currentStatus}
                                    onChange={(e) => this.changeCurrentStatus(e.target.value)}
                                >
                                    {Object.keys(this.state.labels).map((itemP, indexP) => (
                                        <option value={itemP}>{this.state.labels[itemP]}</option>
                                    ))}</NativeSelect>
                            </Div>
                        </SplitCol>
                    </SplitLayout>
                    {this.props.current_user.meta && this.props.current_user.meta.division && this.props.current_user.meta.division.code &&
                        <SplitLayout>
                            <SplitCol>
                                <Div>
                                    <small>Подразделение: <b>{this.props.current_user.meta.division.name}</b></small>
                                </Div>
                            </SplitCol>
                        </SplitLayout>}
                    {!this.state.loading && Array.isArray(this.state.items)
                        && this.state.items.length === 0 && <Cell key={'notFound' + 0}>Ничего не найдено</Cell>}
                    {this.state.items.map((item, index) => {
                        let statusBackground = 'inherit'

                        if (item.statusDoc == constants.CODE_INCOMING_STATUS_IN_PROCESS) {
                            statusBackground = yellowBG
                        }
                        if (item.statusDoc == constants.CODE_INCOMING_STATUS_SENT) {
                            statusBackground = greenBG
                        }

                        let statusDoc = ''

                        statusDoc = `Статус: ${this.state.labels[item.statusDoc]}`

                        return [<SplitLayout>
                            <SplitCol>
                                <RichCell

                                    style={{
                                        background: statusBackground
                                    }}

                                    before={<Switch checked={item.checked}
                                                    disabled={item.statusDoc !== constants.CODE_INCOMING_STATUS_NEW}
                                                    onChange={(e) => this.toggleChecked(e, index)}/>} multiline
                                    subhead={item.date + ' ' + item.time}
                                    bottom={statusDoc}
                                    caption={item.sclad.title}
                                    after={(item.summ * 1).toFixed(2)}
                                    afterCaption={[item.items_cnt, ' ', inducement(item.items_cnt, 'позиция', 'позиции', 'позиций')]}
                                >
                                    {item.nomerDoc ? [item.nomerDoc,
                                        <CopyToClipBoard style={{marginTop: '0px', minWidth: '36px'}}
                                                         text={item.nomerDoc}/>] : 'Номер в 1С еще не получен'}
                                </RichCell>
                            </SplitCol>
                        </SplitLayout>,

                            <hr/>]
                    })}
                    {AdaptivityContext.isMobile ?
                        <div ref={this.ref} key="loader" style={{height: '50px', width: 'auto'}}>{this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера"
                                  after={<Spinner size="large"/>}></Cell> : ""}</div> : this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера" after={<Spinner size="large"/>}></Cell> : ""}
                    {this.state.totalPages > 1 && !AdaptivityContext.isMobile ?
                        <div style={{background: "whitesmoke", position: "fixed", bottom: "52px", zIndex: '99'}}>
                            <Pagination currentPage={this.state.page}
                                        totalPages={this.state.totalPages}
                                        onChange={this.setPage}/>
                        </div> : ''}
                </SplitCol>
            </SplitLayout>
        )
    }

    toggleChecked = (e, index) => {
        if (this.props.current_docs_ids && this.props.current_docs_ids.length > 0) {
            e.stopPropagation()
            e.preventDefault()
            e.currentTarget.checked = false
            this.setState({showDocsAlert: true})
        } else {
            const olds = this.state.items
            const old = this.state.items[index]
            old.checked = !old.checked
            olds[index] = old
            this.setState({items: olds})
        }
    }

    startIncoming = () => {
        const ids = []
        const incomingDocs = {}
        this.state.items.map((el) => {
            if (el.checked) {
                ids.push(el.id)
                const {id, external_id, date, time, nomerDoc, sclad, klient, summ, items_cnt} = el

                incomingDocs[el.id] = {
                    id, external_id, date, time, nomerDoc, sclad, klient, summ, items_cnt
                }
            }
        })
        window.postMessage({type: 'startIncoming', ids, incomingDocs})
    }
}

export default IncomingDocs